'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'PrivateTokenNotProvided',
	message: 'This action requires a private token to be provided, but one was not.',
	soft: true
});
